import { Link } from '@tanstack/react-router';
import type { StaffSettingsNavGroup } from '../../lib/staff-settings-nav';
import { Icon } from '../Icon';

const ITEM =
  'flex h-(--mbm-size-button-small) items-center gap-(--mbm-space-3) rounded-(--mbm-radius-sm) px-(--mbm-space-3) text-body-compact whitespace-nowrap focus-visible:outline-none focus-visible:shadow-(--mbm-shadow-focus-ring)';

/** Left settings navigation (Figma "Admin/Settings nav"). Below `lg` it becomes a horizontal scroller. */
export function SettingsNav({ groups }: { groups: StaffSettingsNavGroup[] }) {
  return (
    <nav
      aria-label="Settings"
      className="flex shrink-0 flex-col gap-(--mbm-space-5) lg:w-(--mbm-layout-staff-settings-nav-width)"
    >
      {groups.map((group) => (
        <div key={group.heading} className="flex flex-col gap-(--mbm-space-1)">
          <h2 className="px-(--mbm-space-3) pb-(--mbm-space-1) text-rail-group text-text-section">{group.heading}</h2>
          <ul className="flex gap-(--mbm-space-1) overflow-x-auto lg:flex-col lg:overflow-visible">
            {group.items.map((item) => (
              <li key={item.to}>
                <Link
                  to={item.to}
                  activeProps={{ className: 'bg-surface-tint text-text-primary', 'aria-current': 'page' }}
                  inactiveProps={{ className: 'text-text-secondary hover:text-text-primary' }}
                  className={ITEM}
                >
                  <Icon icon={item.icon} size="md" />
                  {item.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>
      ))}
    </nav>
  );
}
